import React from "react";
import { Route } from "react-router-dom";

import CatalogoListadoContainer from "../containers/Catalogo";
import PedidosContainer from "../containers/Pedidos";
import PedidosDetalleContainer from "../containers/Pedidos/detail";
import CatalogoContainer from "../containers/Catalogo/catalogoNuevo";
import CatalogoEdicionContainer from "../containers/Catalogo/catalogoEdicion";
import CatalogoAgregarArticulosContainer from "../containers/Catalogo/CatalogoAgregarArticulosContainer";
import ArticuloTextilNuevoContainer from "../containers/Articulos/articuloTextilNuevo";
import PanelControl from "../containers/PanelControl";
import UsuariosContainer from "../containers/Usuarios";
import UsuarioEditContainer from "../containers/Usuarios/edit";
import RubroContainer from "../containers/Rubro";
import SubRubroContainer from "../containers/Rubro/subRubro";
import RubroEdit from "../containers/Rubro/rubroEdit";
import SubRubroEdit from "../containers/Rubro/subrubroEdit";
import MarcaContainer from "../containers/Marca";
import MarcaEdit from "../containers/Marca/marcaEdit";
import ProveedorContainer from "../containers/Proveedor";
import ProveedorEdit from "../containers/Proveedor/proveedorEdit";
import LocalidadEntregaContainer from "../containers/LocalidadEntrega";
import LocalidadEntregaEditContainer from "../containers/LocalidadEntrega/localidadEntregaEdit";
// import PromocionesContainer from '../containers/Promociones'
// import PromocionesEditContainer from '../containers/Promociones/edit'
import ArticuloGenericoNuevoContainer from "../containers/Articulos/articuloGenericoNuevo";
import ArticulosContainer from "../containers/Articulos/index";
import LoginContainer from "../containers/Login";
import ConfirmarCorreoContainer from "../containers/ConfirmarCorreo";
import ContenidoContainer from "../containers/ContenidoContainer";
import ContenidoNuevoContainer from "../containers/ContenidoContainer/ContenidoNuevo";
import ContenidoEditadoContainer from "../containers/ContenidoContainer/ContenidoEditado";
import ConfiguracionesContainer from "../containers/ConfiguracionesContainer";
import PickingContainer from "../containers/PickingContainer";
import CalendarioContainer from "../containers/Pedidos/Calendario";
import OfertaContainer from "../containers/OfertaContainer";
import OfertaNuevoContainer from "../containers/OfertaContainer/OfertaNuevo";
import OfertaEditadoContainer from "../containers/OfertaContainer/OfertaEditado";
import SeleccionSucursalContainer from "../containers/SeleccionSucursal";
import SucursalesContainer from "../containers/SucursalesContainer";
import SucursalEditContainer from "../containers/SucursalesContainer/edit";
import DisenoContainer from "../containers/DisenoContainer";
import PagosYDevolucionesContainer from "../containers/PagosYDevolucionesContainer";
import NivelContainer from "../containers/Nivel";

export const routes = () => {
  return (
    <div>
      {/*<Route path="/" exact component={Home} />*/}

      <Route
        path="/Catalogo/catalogoEdicion/:idCatalogo"
        component={CatalogoEdicionContainer}
        exact
      />
      <Route
        path="/Catalogo/catalogoEdicion/:idCatalogo/agregarArticulos"
        component={CatalogoAgregarArticulosContainer}
        exact
      />
      <Route path="/Articulo" component={ArticulosContainer} exact />
      <Route
        path="/Articulo/articuloGenericoNuevo/:idSuperRubro/:idRubro"
        component={ArticuloGenericoNuevoContainer}
        exact
      />
      <Route
        path="/Articulo/articuloGenericoNuevo/:idSuperRubro/:idRubro/:idArticulo"
        component={ArticuloGenericoNuevoContainer}
        exact
      />
      <Route
        path="/Articulo/articuloNuevo/:idCatalogo"
        component={ArticuloTextilNuevoContainer}
        exact
      />
      <Route
        path="/Articulo/articuloNuevo/:idCatalogo/:idArticulo"
        component={ArticuloTextilNuevoContainer}
        exact
      />
      <Route path="/Articulo/articuloNuevo" component={ArticuloTextilNuevoContainer} exact />
      <Route
        path="/Articulo/articuloNuevo/:idArticulo"
        component={ArticuloTextilNuevoContainer}
        exact
      />
      <Route path="/Picking" component={PickingContainer} exact />
      <Route path="/Catalogo/catalogoNuevo" component={CatalogoContainer} exact />
      <Route path="/Catalogo/catalogoNuevo/:idCatalogo" component={CatalogoContainer} exact />
      <Route path="/Catalogo/:idInstalacion" component={CatalogoListadoContainer} exact />
      <Route path="/Pedidos" component={PedidosContainer} exact />
      <Route
        path="/Pedidos/q/:idCatalogo?/:nombreCatalogo?/:idEstado?"
        component={PedidosContainer}
        exact
      />
      <Route path="/PedidosDetalle/:idPedido" component={PedidosDetalleContainer} exact />
      <Route path="/Calendario" component={CalendarioContainer} exact />
      <Route path="/Usuarios" component={UsuariosContainer} exact />
      <Route path="/Usuarios/Edit/:idUsuario" component={UsuarioEditContainer} exact />
      <Route path="/Rubros" component={RubroContainer} exact />
      <Route path="/Rubros/Edit/:idRubro" component={RubroEdit} exact />
      <Route path="/Subrubros/Edit/:idRubro/:idSubrubro" component={SubRubroEdit} exact />
      <Route path="/Subrubros/:idRubro/:nombreRubro" component={SubRubroContainer} exact />
      <Route path="/Marcas" component={MarcaContainer} exact />
      <Route path="/Marcas/Edit/:idMarca" component={MarcaEdit} exact />
      <Route path="/Proveedores" component={ProveedorContainer} exact />
      <Route path="/Proveedores/Edit/:idProveedor" component={ProveedorEdit} exact />
      <Route path="/LocalidadesEntrega" component={LocalidadEntregaContainer} exact />
      <Route
        path="/LocalidadesEntrega/Edit/:idLocalidadEntrega"
        component={LocalidadEntregaEditContainer}
        exact
      />
      {/* se ocultó la ruta para ocultar el modulo */}
      {/*<Route path="/Promociones" component={PromocionesContainer} exact/>
            <Route path="/Promociones/Edit/:idPromo" component={PromocionesEditContainer} exact/>*/}
      <Route path="/Login" component={LoginContainer} exact />
      <Route path="/Login/:idUsuario/:token?" component={LoginContainer} exact />
      <Route
        path="/ConfirmarCorreoElectronico/:idUsuario/:token"
        component={ConfirmarCorreoContainer}
      />
      <Route path="/" component={PanelControl} exact />
      <Route path="/Contenido" component={ContenidoContainer} exact />
      <Route path="/Contenido/Nuevo" component={ContenidoNuevoContainer} exact />
      <Route path="/Contenido/Editar/:idContenido" component={ContenidoEditadoContainer} exact />
      <Route path="/Configuracion" component={ConfiguracionesContainer} exact />
      <Route path="/Diseno" component={DisenoContainer} exact />
      <Route path="/Oferta" component={OfertaContainer} exact />
      <Route path="/Oferta/Nuevo" component={OfertaNuevoContainer} exact />
      <Route path="/Oferta/Editar/:idOferta" component={OfertaEditadoContainer} exact />
      <Route path="/SeleccionSucursal" component={SeleccionSucursalContainer} exact />
      <Route path="/Sucursales" component={SucursalesContainer} exact />
      <Route path="/Sucursales/Edit/:idSucursal" component={SucursalEditContainer} exact />
      <Route path="/PagosYDevoluciones" component={PagosYDevolucionesContainer} exact />
      <Route path="/Niveles" component={NivelContainer} exact />
    </div>
  );
};
